module.exports = __webpack_public_path__ + "270b1804ded10442dc27e9e0098bb1f3.svg";